import { lazyLoad } from '../../../../shared/utils/loadable';

export const PasswordResetNewCompletePage = lazyLoad(
  () => import('./index'),
  (module) => module.PasswordResetNewComplete,
);
